
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#1565C0] via-[#1976D2] to-[#2E7D32] flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-32 h-32 border-4 border-white rounded-full animate-pulse-soft"></div>
        <div className="absolute bottom-20 left-10 w-24 h-24 border-4 border-white rounded-full animate-pulse-soft" style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute top-1/3 left-1/4 w-16 h-16 border-4 border-white rounded-full animate-pulse-soft" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Logo Container */}
      <div className="animate-fadeIn flex flex-col items-center z-10">
        <div className="w-28 h-28 bg-white rounded-3xl shadow-2xl flex items-center justify-center mb-6 animate-slideUp">
          <div className="text-center">
            <i className="ri-home-gear-line text-4xl text-[#1565C0]"></i>
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-2 animate-slideUp stagger-1">
          خدماتي بلس
        </h1>
        
        <p className="text-white/80 text-sm animate-slideUp stagger-2">
          خدمات منزلية احترافية
        </p>
      </div>

      {/* Loading Indicator */}
      <div className="absolute bottom-20 animate-fadeIn stagger-3">
        <div className="flex gap-2">
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>

      {/* Service Icons */}
      <div className="absolute bottom-32 flex gap-6 animate-fadeIn stagger-4">
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          <i className="ri-nurse-line text-white text-lg"></i>
        </div>
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          <i className="ri-tools-line text-white text-lg"></i>
        </div>
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          <i className="ri-flashlight-line text-white text-lg"></i>
        </div>
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          <i className="ri-drop-line text-white text-lg"></i>
        </div>
      </div>
    </div>
  );
}
